// extracted by mini-css-extract-plugin
export default {"subTitle":"remove-user-modal_subTitle__03m2b","mail":"remove-user-modal_mail__oujVV","user":"remove-user-modal_user__g213Q"};